itsoftApp.createModule("responsiveTables", function() {
    var module = this;

    var initTable = function (table) {
        var heights = [];
        var trElements = table.querySelectorAll("tr");
        var dAttrLabel = "data-label";
        var labels = [];

        var calculateHeight = function () {
            Array.prototype.forEach.call(trElements, function (trElement) {
                var tdElements = trElement.querySelectorAll("th, td");
                var trHeight = trElement.offsetHeight;
                var tdElements = trElement.querySelectorAll("td, th");
                
                for (var i = 0; i < 2; i++) {
                    tdElements[i].style.minHeight = trHeight + "px";
                    tdElements[i].style.height = trHeight + "px";
                    tdElements[i].style.maxHeight = trHeight + "px";

                    if (i === 0) {
                        tdElements[i].style.position = "absolute";
                    }
                }
            });
        }

        // var adaptTable = function () {
        //     var thElements;

        //     Array.prototype.forEach.call(trElements, function (tr, index) {
        //         thElements = tr.querySelectorAll("th:first-child, td:first-child");
        //     });

        //     Array.prototype.forEach.call(thElements, function (th, index) {
        //         console.log(th)
        //         if (index !== 0) {
        //             labels.push(th.textContent.trim());
        //         }
        //     });

        //     Array.prototype.forEach.call(trElements, function (tr, index) {
        //         var tdElements = tr.querySelectorAll("td");
        //         var trIndex = index;

        //         Array.prototype.forEach.call(tdElements, function (td, index) {
        //             var text = td.textContent;
        //             td.textContent = "";
        //             var div = document.createElement("div");
        //             var spanFirst = document.createElement("span");
        //             var spanSecond = document.createElement("span");
        //             spanFirst.textContent = labels[trIndex];
        //             spanSecond.textContent = text;
        //             div.appendChild(spanFirst);
        //             div.appendChild(spanSecond);
        //             td.appendChild(div);
        //         });
        //     });

        //     // var labels = [];
        //     // Array.prototype.forEach.call(thElements, function (el, index) {
        //     //     if (index !== 0) {
        //     //         labels.push(el.textContent.trim());
        //     //     }
        //     // });
        //     // var trElements = table.querySelectorAll("tr");
        //     // Array.prototype.forEach.call(trElements, function (el) {
        //     //     var tdElements = el.querySelectorAll("td");
        //     //     Array.prototype.forEach.call(tdElements, function (el, index) {
        //     //         if (!el.hasAttribute(dAttrLabel)) {
        //     //             el.setAttribute(dAttrLabel, labels[index]);
        //     //         }
        //     //     });
        //     // });
        // }

        calculateHeight();

        // adaptTable();

        itsoftApp.modules.windowResize.addEvent(calculateHeight);
    }

    module.callback = initTable;
});